import { z } from 'zod';

export const TalentProfileEditLanguageFormSchema = z.object({
  languageId: z.string().uuid().nullable(),
  proficiency: z.string().nullable(),
  skill: z.string().nullable(),
  cefr: z.string().nullable(),
});
